import React from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import useTitle from '../../Hooks/useTitle';
import { MdOutlineFileDownload } from 'react-icons/md';
import { Link } from 'react-router-dom';
import resume from '../../images/shakil-ahamed.pdf';
import pHero from '../../images/programming-hero.svg';
import ReactPdf from '../ReactPdf/ReactPdf';

const AboutMore = () => {
    useTitle("About");
    const bannerImage = 'https://i.ibb.co/hgygmvH/Shakil-AHamed.jpg';
    return (
        <div className='px-5 md:px-20 lg:px-32 py-10 md:py-20 lg:py-20 max-w-[1400px] m-auto'>
            <h1 className='text-4xl font-bold mb-10 text-center md:hidden lg:hidden tracking-widest'>About <span className='text-teal-300'>Me</span></h1>
            <div className='flex flex-col md:flex-row lg:flex-row items-center mb-32'>
                <div className='w-full md:w-1/2 lg:w-1/2 rounded-full mb-10 flex justify-center md:justify-between lg:justify-between' data-aos='fade-down'>
                    <PhotoProvider>
                        <PhotoView src={bannerImage}>
                            <img className='about-image rounded-full w-3/4 h-3/4' src={bannerImage} alt="" />
                        </PhotoView>
                    </PhotoProvider>
                </div>
                <div data-aos='fade-down' className='w-full md:w-1/2 lg:w-1/2'>
                    <h1 className='hidden md:block lg:block text-4xl font-bold mb-5 tracking-widest'>About <span className='text-teal-300'>Me</span></h1>
                    <h1 className='text-2xl font-bold text-teal-300'>Shakil Ahamed</h1>
                    <p className='text-sm font-bold mb-4'>Front-end Webdeveloper</p>

                    <p className='opacity-80'>I am twenty four years old. I am doing my
                        <span className='text-teal-100 font-bold'> B.Sc </span>
                        in
                        <span className='text-teal-100 font-bold'> Computer Science and Engineering (CSE) </span>
                        at
                        <span className='text-teal-100 font-bold'> Dhaka International University </span>
                        right now and I specialize in Web Designing and Development. I am working as a full-stack developer for the 2+ years, and I have extensive experience with both front-end and back-end development. I have a deep interest in Web Development and I made some full-stack projects using React, Node, and MongoDB.
                    </p>

                    <Link
                        to={resume}
                        download="Shakil-Ahamed"
                        target="_blank"
                        rel="noreferrer"
                        className='flex items-center gap-1 btn btn-sm btn-accent mt-5 w-1/2'>Resume <MdOutlineFileDownload className='text-xl animate-bounce'></MdOutlineFileDownload>
                    </Link>

                </div>
            </div>

            <div className='flex flex-col md:flex-row lg:flex-row gap-10'>
                {/* EDUCATION */}
                <div className='mb-10 w-full md:w-1/2 lg:w-1/2'>
                    <h1 className='text-xl font-bold mb-5'>EDUCATION</h1>
                    <div className='border-s-4 border-s-slate-400 relative px-4'>
                        <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[15%]'></div>
                        <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                            <p className='font-bold text-teal-400'>2021 - 2022</p>
                            <h1 className='text-xl font-bold'>B.Sc in Computer Science & Engineering (CSE)</h1>
                            <p className='font-bold opacity-70'>Dhaka International University</p>
                            <p className='font-bold opacity-70'>CGPA: Running</p>
                        </div>

                        <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[50%]'></div>
                        <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                            <p className='font-bold text-teal-400'>2017 - 2018</p>
                            <h1 className='text-xl font-bold'>Higher Secondary School Certificate (HSC)</h1>
                            <p className='font-bold opacity-70'>Gaibandha Govt. College</p>
                            <p className='font-bold opacity-70'>GPA : 5.00</p>
                        </div>

                        <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[82%]'></div>
                        <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                            <p className='font-bold text-teal-400'>2015 - 2016</p>
                            <h1 className='text-xl font-bold'>Secondary School Certificate (SSC)</h1>
                            <p className='font-bold opacity-70'>Chhaporhati S.C High School</p>
                            <p className='font-bold opacity-70'>GPA : 5.00</p>
                        </div>
                    </div>
                </div>
                {/* EXPERIENCE */}
                <div className='w-full md:w-1/2 lg:w-1/2'>
                    <h1 className='text-xl font-bold mb-5'>EXPERIENCES</h1>
                    <div className='border-s-4 border-s-slate-400 relative px-4'>
                        <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[15%]'></div>
                        <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                            <p className='font-bold text-teal-400'>2021 - 2022</p>
                            <h1 className='text-xl font-bold'>UI/UX Designer</h1>
                            <p className='font-bold opacity-70'>I'm a product designer and developers with a particular interest and user experience design and future technologies.</p>
                        </div>

                        <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[50%]'></div>
                        <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                            <p className='font-bold text-teal-400'>2022 - Running</p>
                            <h1 className='text-xl font-bold'>Frontend Developer</h1>
                            <p className='font-bold opacity-70'>Skilled Front-end Developer with 2+ years of experience in designing, developing and maintaining front-end web applications.</p>
                        </div>

                        <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[82%]'></div>
                        <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                            <p className='font-bold text-teal-400'>2022 - Running</p>
                            <h1 className='text-xl font-bold'>Mernstack Developer</h1>
                            <p className='font-bold opacity-70'>Currently, I'm working as a programmer, focusing on backend development. I'm helping with creating a salesman's travel app, school app, clinic app and many more using JavaScript, React.js, MongoDb...</p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Course */}
            <div className='py-10'>
                <h1 className='text-xl font-bold mb-5'>COURSES</h1>
                <div className='border-s-4 border-s-slate-400 relative px-4 w-full md:w-1/2 lg:w-1/2'>
                    <div className='w-4 h-4 rounded-full bg-indigo-950 border absolute -left-[10px] top-[40%]'></div>
                    <div data-aos='fade-up' className='border rounded p-4 mb-10 bg-indigo-900 w-full'>
                        <p className='font-bold text-teal-400'>2022 Online</p>
                        <h1 className='text-xl font-bold'>Complete Web Development Course With Jhankar Mahbub</h1>

                        <Link to='https://web.programming-hero.com/home' target='_blank' className='font-bold mt-5 flex items-center gap-1 text-xs hover:text-slate-300'>
                            <img className='w-5 bg-purple-500 rounded-full text- cursor-pointer' src={pHero} alt="" />Programming Hero
                        </Link>
                    </div>
                </div>
            </div>

            {/* React Pdf */}
            <div className='hidden md:block'>
                <h1 className='text-xl font-bold mb-10'>RESUME</h1>
                <ReactPdf></ReactPdf>
            </div>

        </div>
    );
};

export default AboutMore;